import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

/**
 * Modal de confirmação de recebimento de PIX
 */
export default function PixReceivedModal({
  open,
  onOpenChange,
  pix,
  onConfirm,
  loading,
}) {
  if (!pix) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-600" />
            Confirmar Recebimento PIX
          </DialogTitle>
          <DialogDescription>
            Confirme que você recebeu este pagamento via PIX
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="bg-gray-50 rounded-lg p-4 space-y-3">
            <div>
              <p className="text-sm font-medium text-gray-500">
                ID da Transação
              </p>
              <p className="text-base font-mono text-gray-900 break-all">
                {pix.txid}
              </p>
            </div>

            {(pix.amount || pix.valor) && (
              <div>
                <p className="text-sm font-medium text-gray-500">Valor</p>
                <p className="text-2xl font-bold text-green-600">
                  R$ {(pix.amount || pix.valor).toFixed(2)}
                </p>
              </div>
            )}
          </div>

          <p className="text-sm text-gray-600">
            Ao confirmar, este PIX será marcado como recebido e não poderá ser
            desfeito.
          </p>
        </div>

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            {loading ? "Confirmando..." : "Confirmar Recebimento"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
